import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import MenuPage from "@/pages/MenuPage";
import AdminPage from "@/pages/AdminPage";
import { LanguageProvider } from "@/context/LanguageContext";
import { CategoriesProvider } from "@/context/CategoriesContext";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { BranchProvider } from "@/context/BranchContext";

function App() {
  return (
    <LanguageProvider>
      <SettingsProvider>
        <AuthProvider>
          <CategoriesProvider>
            <BranchProvider>
              <div className="App">
                <BrowserRouter>
                  <Routes>
                    <Route path="/" element={<MenuPage />} />
                    <Route path="/admin" element={<AdminPage />} />
                  </Routes>
                </BrowserRouter>
                <Toaster position="top-center" richColors />
              </div>
            </BranchProvider>
          </CategoriesProvider>
        </AuthProvider>
      </SettingsProvider>
    </LanguageProvider>
  );
}

export default App;
